import React from "react";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import HistoryModal from "../HistoryModal";
import { ConfirmationActiveSaleSupport } from "./ConfirmationActiveSaleSupport";
import { ConfirmationFavorite } from "./ConfirmationFavorite";
import { ConfirmationActivationDeactivationMessageModal } from "@components/Common/ConfirmationActivationDeactivationMessageModal";

export function SaleSupportModals({
    isInInitializationModalOpened,
    setIsInInitializationModalOpened,
    isAddNewSaleSupportButtonClicked,
    setIsAddNewSaleSupportButtonClicked,
    setIsEdited,
    setIsInlineErrorCleared,
    isHistoryModalOpened,
    setIsHistoryModalOpened,
    selectedRows,
    isModalConfirmationOpened,
    setIsModalConfirmationOpened,
    setFranchiseDataIsUpdated,
    isFavoriteModified,
    setIsFavoriteModified,
    rowData,
    isActionsClicked,
    setIsActionsClicked,
    validationAction,
    actions,
    activationDeactivationMessageModalOpened,
    oneShop,
}: any) {
    return (
        <>
            {isInInitializationModalOpened && (
                <ConfirmationInitializationMessage
                    isModalOpened={isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddNewSaleSupportButtonClicked}
                    isClicked={isAddNewSaleSupportButtonClicked}
                    setIsEdited={setIsEdited}
                    setIsInlineErrorCleared={setIsInlineErrorCleared}
                />
            )}

            {isHistoryModalOpened && (
                <HistoryModal
                    ids={selectedRows}
                    setIsModalOpened={setIsHistoryModalOpened}
                    isModalOpened={isHistoryModalOpened}
                />
            )}

            {isModalConfirmationOpened && (
                <ConfirmationActiveSaleSupport
                    setIsModalConfirmationOpened={setIsModalConfirmationOpened}
                    isModalConfirmationOpened={isModalConfirmationOpened}
                    setDataIsUpdated={setFranchiseDataIsUpdated}
                    selectedRows={selectedRows}
                />
            )}

            {isFavoriteModified && (
                <ConfirmationFavorite
                    isModalOpened={isFavoriteModified}
                    setIsModalOpened={setIsFavoriteModified}
                    selectedRowData={rowData}
                />
            )}

            {isActionsClicked && (
                <ConfirmationUpdatingDataMessageModal
                    isModalOpened={isActionsClicked}
                    setIsModalOpened={setIsActionsClicked}
                    validationAction={validationAction}
                    actions={actions}
                    setIsEdited={setIsEdited}
                />
            )}

            {activationDeactivationMessageModalOpened && oneShop && (
                <ConfirmationActivationDeactivationMessageModal />
            )}
        </>
    );
}

export default SaleSupportModals;
